import { createSelector, Selector } from 'reselect';
import { ReduxState } from '../state';
import { CourseAppearanceSettingsState } from './state';
import { selectType, selectQueryObject } from '../location/selectors.common';

// import { CourseThemeDataFull } from "../Courses/types";

export const selectCourseApperanceSettings = (
  state: ReduxState
): CourseAppearanceSettingsState => state.CourseAppearanceSettings;

export const selectIsOnCourseAppearanceSetting: Selector<
  ReduxState,
  boolean
> = createSelector([selectType, selectQueryObject], (type, query) => {
  const { action } = query;
  return type === 'ROUTE_COURSE_ADMIN' && action === 'appearance';
});
